import React from "react";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import JumboIconButton from "@jumbo/components/JumboIconButton";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import { ThemeProvider, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

const MessagesTriggerButton = ({ notifications }) => {
  const { headerTheme } = useJumboHeaderTheme();

  const unreadNotifications = notifications.filter(
    (opt) => opt?.Open_flg === false
  )?.length || 0;


  let filterItems;
  if (unreadNotifications > 0) {
    if (unreadNotifications > 9) {
      filterItems = "9+";
    } else {
      filterItems = unreadNotifications;
    }
  }

  return (
    <ThemeProvider theme={headerTheme}>
      <JumboIconButton badge={{ variant: "standard" }} elevation={25} filterItems={filterItems}>
        <Tooltip title="Reminder" placement="top-start">
          <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 18 }} />
        </Tooltip>
      </JumboIconButton>
    </ThemeProvider>
  );
};

MessagesTriggerButton.propTypes = {
  notifications: PropTypes.number.isRequired,
};

export default MessagesTriggerButton;
